import { CircleX, FileIcon, Paperclip } from "lucide-react";
import { cn } from "@/lib/utils";
import { images } from "@/assets";
import { toast } from "../Toast";

const FileInput = ({
  file,
  fileInputRef,
  setFile,
  accept,
  disabled,
  maxSize, // in mb
  placeholder
}: any) => {
  const handleClick = () => {
    if (!disabled) fileInputRef?.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];

    if (selectedFile) {
      const fileSizeInMB = (selectedFile?.size / (1024 * 1024)).toFixed(2);
      if (maxSize && parseFloat(fileSizeInMB) > maxSize) {
        fileInputRef.current.value = null;
        toast({
          message: `File size should be less than ${maxSize} MB`,
          type: "error",
        });
      } else {
        setFile(selectedFile);
        event.target.value = "";
      }
    }
  };

  return (
    <div className="flex flex-col w-full max-w-md text-start relative">
      {/* File Input Field */}
      <div
        className={cn(
          "flex items-center justify-between w-full border border-g-400 rounded-lg px-3 py-2 cursor-pointer h-[40px]",
          disabled ? "opacity-50 cursor-not-allowed" : "hover:border-gray-400"
        )}
        onClick={handleClick}
      >
        <div className="flex flex-row gap-2 items-center">
          {file?.name ? (
            accept?.includes("pdf") ? (
              <img src={images.pdf_icon} className="h-8 w-7" />
            ) : (
              <FileIcon className="text-g-500" />
            )
          ) : (
            ""
          )}
          <div className="flex flex-col">
            <span
              className={`text-gray-500 text-sm break-all line-clamp-1 ${
                file?.name ? "text-primary" : ""
              }`}
            >
              {file?.name || placeholder || "Please attach"}
            </span>
            {file?.size && (
              <span className="text-[10px] text-g-300 -mt-1">
                size: {parseFloat((file?.size / 1024).toString()).toFixed(2)} KB
              </span>
            )}
          </div>
        </div>
        <div>
          {disabled ? (
            <></>
          ) : file?.name ? (
            <CircleX
              className={cn(
                "text-gray-400 h-5 w-5",
                disabled ? "cursor-not-allowed" : ""
              )}
              onClick={(e) => {
                if (!disabled) {
                  e.preventDefault();
                  e.stopPropagation();
                  setFile(null);
                }
              }}
            />
          ) : (
            <Paperclip className="text-gray-400 h-5 w-5" />
          )}
        </div>
      </div>

      {/* Hidden File Input */}
      <input
        type="file"
        ref={fileInputRef}
        className="hidden"
        onChange={handleFileChange}
        accept={accept}
      />
    </div>
  );
};

export default FileInput;
